/**
 * @file Batched workplace calendar availability API
 * @backend_route /api/v1/workplaces/calendar-availability/
 */

import { httpClient } from './http'

export type WorkplaceCalendarSource =
  | 'workday_override'
  | 'holiday_override'
  | 'legal_workday'
  | 'legal_holiday'
  | 'weekly_rule'

export interface WorkplaceCalendarAvailabilityDate {
  date: string
  is_workday: boolean
  source: WorkplaceCalendarSource
  calendar_scope: 'workplace' | 'enterprise' | 'default'
}

export interface WorkplaceCalendarAvailabilityItem {
  workplace_id: string
  dates: WorkplaceCalendarAvailabilityDate[]
}

export interface WorkplaceCalendarAvailabilityResponse {
  date_from: string
  date_to: string
  items: WorkplaceCalendarAvailabilityItem[]
}

export interface WorkplaceCalendarAvailabilityParams {
  workplace_ids: string
  date_from: string
  date_to: string
}

export function getWorkplaceCalendarAvailability(
  params: WorkplaceCalendarAvailabilityParams,
  signal?: AbortSignal,
): Promise<WorkplaceCalendarAvailabilityResponse> {
  return httpClient.get<WorkplaceCalendarAvailabilityResponse>(
    'workplaces/calendar-availability/',
    { params, signal },
  )
}
